import { combineReducers } from 'redux';
import {
  BROKER_OMS_GENERAL_ERROR,
  BROKER_OMS_GENERAL_LOADING,
  BROKER_OMS_GENERAL_REQUEST,
  BROKER_OMS_GENERAL_SUCCESS,
  BROKER_OMS_REQUEST_UPDATE_ORDER_TYPE,
  BROKER_OMS_REQUEST_UPDATE_REQUEST_DATA,
  BROKER_OMS_REQUEST_UPDATE_REQUEST_DATA_DYNAMIC,
} from '../../constants/ActionTypes';
import { moduleBrokerName } from '../../module-params';

const general = (
  state = {
    loading: false,
    errorMessage: '',
    successMessage: '',
  },
  action
) => {
  switch (action.type) {
    case BROKER_OMS_GENERAL_LOADING:
      return {
        ...state,
        loading: action.data,
      };
    case BROKER_OMS_GENERAL_REQUEST:
      return {
        ...state,
        errorMessage: '',
        successMessage: '',
      };
    case BROKER_OMS_GENERAL_ERROR:
      return {
        ...state,
        errorMessage: action.data,
        successMessage: '',
      };
    case BROKER_OMS_GENERAL_SUCCESS:
      return {
        ...state,
        errorMessage: '',
        successMessage: action.data,
      };
    default:
      return state;
  }
};

const requestData = (
  state = {
    data: '',
    updatedAt: null,
  },
  action
) => {
  switch (action.type) {
    case BROKER_OMS_REQUEST_UPDATE_ORDER_TYPE:
      if (!action.data.data) {
        return state;
      }

      return {
        ...state,
        data: JSON.stringify(action.data.data, null, 2),
        updatedAt: Date.now(),
      };
    case BROKER_OMS_REQUEST_UPDATE_REQUEST_DATA_DYNAMIC:
      if (!action.data) {
        return state;
      }

      return {
        ...state,
        data: JSON.stringify(action.data, null, 2),
        updatedAt: Date.now(),
      };
    case BROKER_OMS_REQUEST_UPDATE_REQUEST_DATA:
      return {
        ...state,
        data: action.data,
        updatedAt: Date.now(),
      };
    default:
      return state;
  }
};

const orderType = (
  state = {
    brokerName: moduleBrokerName,
    type: undefined,
    updatedAt: null,
  },
  action
) => {
  switch (action.type) {
    case BROKER_OMS_REQUEST_UPDATE_ORDER_TYPE:
      return {
        ...state,
        type: action.data.type ? action.data.type : state.type,
        brokerName: action.data.brokerName
          ? action.data.brokerName
          : state.brokerName,
        updatedAt: Date.now(),
      };

    default:
      return state;
  }
};

const brokerOmsRequest = combineReducers({
  orderType,
  requestData,
  general,
});

export default brokerOmsRequest;
